import React, { useCallback, useEffect, useState } from "react";
import { getAuthReq, postAuthReq } from "../../utils/apiHandlers";
import { useSelector } from "react-redux";
import moment from "moment";
import { reactIcons } from "../../utils/icons";
import Spinner from "../../components/loaders/Spinner";
import { getQueryString } from "../../utils/function";
import { debounce } from "lodash";
import useDateFilter from "../../hooks/useDateFilter";
import { toast } from "react-toastify";
import CommissionReportTable from "./CommissionReportTable";

const headings = [
  "S.No.",
  "Beneficiary Name",
  "Purchased By",
  "Date",
  "Email",
  "Mobile",
  "Amount",
  "Commission",
  "Beneficiary Type"
];

const Commission = () => {
  const take = 8;
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { userData } = useSelector((state) => state?.user || {});
  const { selectedFromDate, selectedToDate, dateRangeFilterUi } =
    useDateFilter();

  const [payoutAount, setPayoutAmount] = useState("");

  const [listData, setListData] = useState({
    count: 0,
    data: []
  });

  const handlePage = (e, page) => {
    e.preventDefault();
    setPageNumber(page);
  };
  const fetchCommissionReports = async () => {
    setIsLoading(true);
    const query = getQueryString({
      skip: (pageNumber - 1) * take,
      take: take,
      startDate: moment(selectedFromDate).format("YYYY-MM-DD"),
      endDate: moment(selectedToDate).format("YYYY-MM-DD"),
      search: search,
      powerFranchiseId: userData?.id
    });
    const res = await getAuthReq(
      `/reports/commission/power-franchise/downline?${query}`
    );
    const { status, data } = res;
    if (status) {
      setListData({ count: Number(data.count), data: data.data });
    }
    setIsLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchUsers = useCallback(
    debounce(() => fetchCommissionReports(), 500), // 500ms debounce delay
    [pageNumber, take, selectedFromDate, selectedToDate, search, userData?.id]
  );

  useEffect(() => {
    if (userData?.id) {
      debouncedFetchUsers();
    }
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers, userData?.id]);

  const handleExportExcel = async () => {
    setIsLoading(true);
    const query = getQueryString({
      startDate: moment(selectedFromDate).format("YYYY-MM-DD"),
      endDate: moment(selectedToDate).format("YYYY-MM-DD"),
      search: search,
      powerFranchiseId: userData?.id
    });
    const res = await getAuthReq(
      `/reports/commission/power-franchise/downline-csv?${query}`
    );
    const { status, data } = res;
    if (status) {
      setIsLoading(false);
      toast.dismiss();
      window.open(data?.url);
      toast.success(data?.message);
    } else {
      setIsLoading(false);
      toast.dismiss();
      toast.error(res.error.message);
    }
  };

  return (
    <>
      {isLoading && <Spinner />}

      <div className="flex flex-col lg:flex-row lg:items-center  justify-between w-full xl:w-auto mb-5 mt-5">
        <div>
          <h4 className="cursor-pointer text-white text-start md:text-center text-16 md:text-[24px] lg:text-[24px] mb-4 md:mb-0">
            Commission Reports
          </h4>
        </div>
        <div className="flex flex-col md:flex-row gap-4 items-center">
          {dateRangeFilterUi()}
          <div className="relative  md:w-[220px] w-1/2">
            <input
              className="p-2 pl-3 pr-8 rounded-lg border border-[#69CEA6] bg-transparent text-white h-[40px]"
              type="text"
              value={search}
              placeholder="Search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <span className="absolute text-18 top-[calc(50%-9px)] right-3 text-white">
              {reactIcons.search}
            </span>
          </div>

          <button
            type="button"
            onClick={handleExportExcel}
            disabled={isLoading}
            className="w-1/2 md:w-[180px] flex h-[40px] md:h-[40px] text-10 md:text-16 btn-danger p-[10px] md:p-3 rounded-md font-semibold  justify-center items-center gap-2"
          >
            {reactIcons.excell} Export to excel
          </button>
        </div>
      </div>
      <div className="">
        <CommissionReportTable
          headings={headings}
          pageNumber={pageNumber}
          listData={listData}
          handlePage={handlePage}
          take={take}
          setPageNumber={setPageNumber}
          setIsLoading={setIsLoading}
          fetchAllPayout={fetchCommissionReports}
        />
      </div>
    </>
  );
};

export default Commission;
